import React from 'react';
import moment from 'moment';
import { getUtility } from '@livable/saas-react-components';

const trimNumber = (value, decimals) =>
  value === null || value === undefined ? '' : String(Number(Number(value).toFixed(decimals)));

export const meterLineCount = (item) => item?.submeterMeters?.length || 0;

// Where each item starts when its meter lines count as printed lines, so page and column
// limits apply to what is printed. Without meter lines this is each item's index.
export const lineStarts = (items = []) => {
  const starts = [];
  let next = 0;
  items.forEach((item) => {
    starts.push(next);
    next += 1 + meterLineCount(item);
  });
  return starts;
};

export const lineCount = (items = []) =>
  items.reduce((total, item) => total + 1 + meterLineCount(item), 0);

const meterLine = (meter, charge) => {
  const start = meter.startReadDateOnly || charge.startDateOnly;
  const end = meter.endReadDateOnly || charge.endDateOnly;
  const unit = meter.unitOfMeasure ? ` ${meter.unitOfMeasure}` : '';
  return `${moment(start).format('MM/DD')}-${moment(end).format('MM/DD/YYYY')}: reads ${trimNumber(
    meter.startRead,
    4,
  )}-${trimNumber(meter.endRead, 4)}, usage ${trimNumber(meter.usage, 4)}${unit}, rate $${trimNumber(meter.rate, 4)}`;
};

export const SubmeterMeterLines = ({ charge }) =>
  charge.submeterMeters.map((meter, index) => (
    <div
      key={`${charge.financialTransactionId}-meter-${index}`}
      className="light-text small-text"
      style={{ marginLeft: '16pt' }}
    >
      {meterLine(meter, charge)}
    </div>
  ));

export const SubmeterDisclosures = ({ disclosures, utilityInfo }) => (
  <div>
    <div className="section-title">Utility provider information</div>
    {disclosures.map((disclosure) => {
      const utility = utilityInfo?.find((i) => i.utilityId === disclosure.utilityId);
      const title = getUtility(utility?.utilityTypeName || utility?.type)?.title || utility?.utilityTypeName || '';
      const provider = [disclosure.providerName, disclosure.providerPhone].filter(Boolean).join(', ');
      return (
        <div key={disclosure.utilityId} className="small-text" style={{ breakInside: 'avoid', marginTop: '4pt' }}>
          <div className="bold-text">
            {title}
            {provider && `: ${provider}`}
          </div>
          {disclosure.billingAgentDisclosure && <div>{disclosure.billingAgentDisclosure}</div>}
          {disclosure.leakServiceContact && <div>Leaks/service: {disclosure.leakServiceContact}</div>}
        </div>
      );
    })}
  </div>
);

export const KeepTogether = ({ when, children }) =>
  when ? <div style={{ breakInside: 'avoid' }}>{children}</div> : <>{children}</>;
